import Vue from 'vue';
import {
  formatNumber,
  alignForNumber,
  LinkCellRenderer,
  autoResize,
  getPinnedRowData
} from '@/helpers/renderHelpers'
import { handlerResponse, addColIdToColumns } from '@/helpers/commonHelpers';

export default {
  namespaced: true,
  state: {
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter(params) {
          const columnName = params.colDef.field;
          const minDigits = columnName === 'base_curr_to_invoice_currency_rate' || columnName === 'base_curr_to_payment_currency_rate'
            ? 5 : 2;
          return formatNumber(params.value, minDigits);
        },
        cellStyle(params) {
          return alignForNumber(params.value);
        }
      },
      components: {
        'SaleAgentInvoiceLink': LinkCellRenderer('invoice_id', '/sales-agent-invoices/'),
        'InvoiceLink': LinkCellRenderer('invoice_id', '/sales-invoice/', true),
        'PayerLink': LinkCellRenderer('payer_id', '/partners/'),
        'RecipientLink': LinkCellRenderer('recipient_id', '/partners/'),
        'InvoiceConnectorLink': LinkCellRenderer('invoice_id', '/sales-invoice/'),
        'PurchaseInvoiceLink': LinkCellRenderer('invoice_id', '/purchase-invoice/')
      },
      getRowStyle(params) {
        if (params.node.rowPinned) {
          return {'font-weight': 'bold'};
        }
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        }
      }
    },
    invoiceListData: [],
    invoiceListColumns: [],
    boundedInvoicesData: [],
    invoiceListPinnedRowData: [],
    boundedInvoicesColumns: [],
    boundedInvoicesPinnedRowData: [],
    listCurrencySymbolsOfInvoiceList: {},
    comments: [],
    documents: []
  },
  getters: {
    invoiceListGrid(state) {
      return {...state.gridOptions};
    },
    boundedInvoicesGrid(state) {
      return {...state.gridOptions};
    }
  },
  mutations: {
    setInvoiceList(state, data) {
      if (data.data) {
        state.invoiceListData = data.data;
        state.invoiceListColumns = addColIdToColumns(data.used_columns);
        state.invoiceListPinnedRowData = getPinnedRowData(data.total, 'name', 'value');
      }
      else {
        state.invoiceListData = data;
        state.invoiceListPinnedRowData = data;
      }
    },
    setBoundedInvoices(state, data) {
      if (data.data) {
        state.boundedInvoicesData = data.data;
        state.boundedInvoicesColumns = addColIdToColumns(data.used_columns).map(col => {
          if (col.field === 'invoice_number') {
            col.cellRendererSelector = (params) => {
              const invoiceType = params.data.invoice_class_name;
              if (invoiceType === 'SaleAgentInvoice') {
                return {component: 'SaleAgentInvoiceLink'};
              } else if (invoiceType === 'PurchaseInvoice') {
                return {component: 'PurchaseInvoiceLink'};
              } else {
                return {component: 'InvoiceConnectorLink'};
              }
            }
          }
          return col;
        });
        state.boundedInvoicesPinnedRowData = getPinnedRowData(data.total, 'name', 'value');
      }
      else {
        state.boundedInvoicesData = data;
        state.boundedInvoicesPinnedRowData = data;
      }
    },
    setListCurrencySymbolsOfInvoiceList(state, data) {
      state.listCurrencySymbolsOfInvoiceList = Object.assign({}, ...data.map(item => ({[item['currency_symbol']]: 0})));
    },
    setCommentsList(state, data) {
      state.comments = data;
    },
    setDocumentsList(state, data) {
      state.documents = data;
    }
  },
  actions: {
    async loadInvoiceListData(store, payLoad) {
      try {
        const data = await Vue.http.get(`partner/payments/${payLoad.id}/invoices_for_payment/`, {params: payLoad.params})
          .then(handlerResponse);
        store.commit('setInvoiceList', data);
        if (data.data) {
          store.commit('setListCurrencySymbolsOfInvoiceList', data.data);
        }
      } catch (exception) {
        console.log(exception);
      }
    },
    loadBoundedInvoices(store, payLoad) {
      Vue.http.get(`partner/payments/${payLoad.id}/invoice_transfers/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setBoundedInvoices', data);
        });
    },
    loadCommentsList(store, payLoad) {
      Vue.http.get(`partner/payments/${payLoad.id}/comments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setCommentsList', data);
        });
    },
    loadDocumentsList(store, payLoad) {
      Vue.http.get(`partner/payments/${payLoad.id}/attachments/`)
        .then(handlerResponse)
        .then(data => {
          store.commit('setDocumentsList', data);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/accounts/payments/payment.js